import React from "react";
import { Link } from "react-router-dom";

const PRODUCTS = [
  { id: "e22898f4-10e3-e611-80ec-5065f38b5621", name: "OPEN" },
  { id: 2, name: "Harvest" },
  { id: 3, name: "Grid" },
  { id: "07e0eb22-fc86-eb11-a812-000d3ab52e95", name: "Next" },
];
const LANGUAGE_MAP = {
  en: "English",
  de: "German",
  pl: "Polish",
};
const getProductName = (crmProductId) =>
  PRODUCTS.find((p) => p.id === crmProductId)?.name || "Unknown";

const getDocsColumns = (inactiveFunc) => {
  return [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Title",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => <span>{text}</span>,
      width: "30%",
    },
    {
      title: "Product",
      dataIndex: "crmProductId",
      sorter: (a, b) => a.crmProductId.length - b.crmProductId.length,
      render: (productId) => <span>{getProductName(productId)}</span>,
      width: "30%",
    },
    {
      title: "Language",
      dataIndex: "language",
      sorter: (a, b) => a.language.localeCompare(b.language),
      render: (lang) => <span>{LANGUAGE_MAP[lang] || lang}</span>,
      width: "30%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to={`/AddDocuments/${record.id}`}>
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => inactiveFunc(record.id)}
            >
              <i className="fa fa-ban m-r-5" /> Inactive
            </button>
          </div>
        </div>
      ),
      width: "40%",
    },
  ];
};

export default getDocsColumns;
